import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { Sustainability } from './Sustainability';
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';

import onLife from 'img/onLife.png';
import greenPower from 'img/green-power.svg';
import greenWorld from 'img/green-world.svg';

import DomainSettingService from 'services/domainSetting.service';
import { IBatchRequestResponse } from 'models/Batch';
import { IDomainSetting } from 'models/DomainSetting';

import { GreenDeliveryDataProps } from './interface';
import keycloak from 'utils/keycloak';

import {
  Container,
  Content,
  TextOnLife,
  LinkDiscoverOurProgram,
  Totalizer,
  TotalizerDescription
} from './styles';

export const GreenDelivery: React.FC = () => {

  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const _domainSettingService = new DomainSettingService();

  const [greenDeliveryData, setGreenDeliveryData] = useState<GreenDeliveryDataProps>();

  useEffect(() => {
    if (keycloak.token)
      getDataGreenDelivery();
  }, [keycloak.token]);

  const getDataGreenDelivery = () => {
    _domainSettingService
      .get(undefined, undefined, 'value asc', {
        and: [
          { identifier: { eq: 'GreenDelivery' } },
          { enabled: { eq: true } }
        ]
      })
      .then((result: IBatchRequestResponse<IDomainSetting> | undefined) => {
        if (result?.data) {
          const { value } = result?.data?.[0];
          setGreenDeliveryData(JSON.parse(value || ''));
        }
      });
  };

  const handleDiscoverOurProgram = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'Sustentabilidade Viveo',
        show: true,
        content: Sustainability,
        state: greenDeliveryData
      },
    });
  };

  const userTypeIsCustomer: boolean = user?.userType === 'customer';
  const userTypeIsSupplier: boolean = user?.userType === 'supplier';

  return (
    <Container userTypeIsCustomer={userTypeIsCustomer} userTypeIsSupplier={userTypeIsSupplier}>
      <Text size={24} className="color-primary font-bold pb-1">
        Sustentabilidade Viveo
      </Text>

      <Content userTypeIsCustomer={userTypeIsCustomer}>
        <img
          src={onLife}
          alt="onlife cuidado que vai além."
        />

        <div>
          <TextOnLife>
            Somos um ecossistema cada vez mais diversificado e comprometido com a missão de simplificar o mercado de saúde,
            com o objetivo de gerar impactos positivos e oferecer soluções completas para nossos clientes e sociedade.
          </TextOnLife>

          <LinkDiscoverOurProgram
            className="color-primaryViveo"
            onClick={handleDiscoverOurProgram}
          >
            + Conheça nosso programa
          </LinkDiscoverOurProgram>
        </div>

        <Row className='grid-gap-1'>
          <img
            src={greenPower}
            alt="ícone poder Verde"
            width={93}
            height={93}
          />

          <div className='d-block'>
            <Totalizer>{greenDeliveryData?.totalDeliveries}</Totalizer>
            <TotalizerDescription>
              {greenDeliveryData?.descriptionDeliveries}
            </TotalizerDescription>
          </div>
        </Row>

        <Row className='grid-gap-1'>
          <img
            src={greenWorld}
            alt="ícone planeta Verde"
            width={93}
            height={93}
          />

          <div className='d-block'>
            <Totalizer> {greenDeliveryData?.reducedAmount}</Totalizer>
            <TotalizerDescription>
              de redução de CO2 emitidos na atmosfera
            </TotalizerDescription>
          </div>
        </Row>
      </Content>
    </Container>
  );
};